import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DEFAULT_COPYRIGHT_HOLDER, getCopyrightText, useCopyrightHolder } from './copyright';

export {
  DEFAULT_COPYRIGHT_HOLDER,
  getCopyrightText,
  resolveCopyrightHolder,
  resolveCopyrightHolderName,
  useCopyrightHolder,
  useCopyrightBuilderLogo,
} from './copyright';

const NoticeRoot = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  padding: theme.spacing(2),
  boxSizing: 'border-box',
}));

/**
 * In-flow copyright for the bottom of a list or document page (not viewport-fixed).
 *
 * Pass `holderName` directly, or `ownerRealmId` / `vendorId` to resolve the holder
 * (own builder name, client-vendors, or public realm on hashed Library views).
 * Falls back to IBACOS only when no company can be resolved.
 */
export default function CopyrightNotice(props) {
  const { holderName, ownerRealmId, vendorId, className, sx } = props;
  const resolved = useCopyrightHolder({ ownerRealmId, vendorId });
  const name = holderName || resolved || DEFAULT_COPYRIGHT_HOLDER;

  return (
    <NoticeRoot className={className} sx={sx}>
      <Typography variant="caption" color="text.secondary" component="p" sx={{ m: 0 }}>
        {getCopyrightText(name)}
      </Typography>
    </NoticeRoot>
  );
}
